import { IPayerRow } from "../../services/search";
import { QUERY_PAYER_ROWS } from "../search/payer/queries/useQueryPayerRows";
import { WSQueryClient } from "../helpers";

export function getPayerRowCache(payerId: string): IPayerRow | undefined {
  const datas: any[] = WSQueryClient.getQueriesData([QUERY_PAYER_ROWS]);

  for (const data of datas) {
    const payers = data[1]?.pages[0];

    if (!Array.isArray(payers)) {
      continue;
    }

    const payerRow = payers.find(row => row.payerId === payerId);

    if (payerRow) {
      return payerRow;
    }
  }

  return undefined;
}
